module.exports = __webpack_public_path__ + "static/img/banner-1.5dbbc1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner-1.png
// module id = 8NoG
// module chunks = 7